var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Error"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 21.8398L12 2.83984L23 21.8398H1ZM12.1 18.9148C12.3167 18.9148 12.4958 18.844 12.6375 18.7023C12.7792 18.5607 12.85 18.3815 12.85 18.1648C12.85 17.9482 12.7792 17.769 12.6375 17.6273C12.4958 17.4857 12.3167 17.4148 12.1 17.4148C11.8833 17.4148 11.7042 17.4857 11.5625 17.6273C11.4208 17.769 11.35 17.9482 11.35 18.1648C11.35 18.3815 11.4208 18.5607 11.5625 18.7023C11.7042 18.844 11.8833 18.9148 12.1 18.9148ZM11.35 16.1398H12.85V10.5398H11.35V16.1398Z",
    fill: "#DE350B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.72d0e142f2a155b3033ba0bf0b924f9a.svg";
export { ForwardRef as ReactComponent };